<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Chassis Options</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        <div class="configurationDetailRow">
          @if (modelSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Model:</label>
              <select class="halfWidthInputField" #modelInput
                [class.invalidConfigurationSelection]="isInvalidSelection(modelSelection.Name)"
                (change)="selectionChanged(modelSelection, modelInput.value)"
                [value]="modelSelection.Value.toString()">
                @for (allowable of modelSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="modelSelection.Value && modelSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (sizeSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Size:</label>
              <select class="halfWidthInputField" #sizeInput
                [class.invalidConfigurationSelection]="isInvalidSelection(sizeSelection.Name)"
                (change)="selectionChanged(sizeSelection, sizeInput.value)"
                [value]="sizeSelection.Value.toString()">
                @for (allowable of sizeSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="sizeSelection.Value && sizeSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (chassisStyleSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Chassis Style:</label>
              <select class="halfWidthInputField" #chassisStyleInput
                [class.invalidConfigurationSelection]="isInvalidSelection(chassisStyleSelection.Name)"
                (change)="selectionChanged(chassisStyleSelection, chassisStyleInput.value)"
                [value]="chassisStyleSelection.Value.toString()">
                @for (allowable of chassisStyleSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="chassisStyleSelection.Value && chassisStyleSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (unitVoltageSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Voltage:</label>
              <select class="halfWidthInputField" #unitVoltageInput
                [class.invalidConfigurationSelection]="isInvalidSelection(unitVoltageSelection.Name)"
                (change)="selectionChanged(unitVoltageSelection, unitVoltageInput.value)"
                [value]="unitVoltageSelection.Value.toString()">
                @for (allowable of unitVoltageSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="unitVoltageSelection.Value && unitVoltageSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (controlsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Controls:</label>
              <select class="halfWidthInputField" #controlsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(controlsSelection.Name)"
                (change)="selectionChanged(controlsSelection, controlsInput.value)"
                [value]="controlsSelection.Value.toString()">
                @for (allowable of controlsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="controlsSelection.Value && controlsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (drainPanOptionsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Drain Pan Options:</label>
              <select class="halfWidthInputField" #drainPanInput
                [class.invalidConfigurationSelection]="isInvalidSelection(drainPanOptionsSelection.Name)"
                (change)="selectionChanged(drainPanOptionsSelection, drainPanInput.value)"
                [value]="drainPanOptionsSelection.Value.toString()">
                @for (allowable of drainPanOptionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="drainPanOptionsSelection.Value && drainPanOptionsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (autoFlowRegulatorSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Auto Flow Regulator:</label>
              <select class="halfWidthInputField" #autoFlowRegulatorInput
                [class.invalidConfigurationSelection]="isInvalidSelection(autoFlowRegulatorSelection.Name)"
                (change)="selectionChanged(autoFlowRegulatorSelection, autoFlowRegulatorInput.value)"
                [value]="autoFlowRegulatorSelection.Value.toString()">
                @for (allowable of autoFlowRegulatorSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="autoFlowRegulatorSelection.Value && autoFlowRegulatorSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (controlOptionsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Control Options:</label>
              <select class="halfWidthInputField" #controlOptionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(controlOptionsSelection.Name)"
                (change)="selectionChanged(controlOptionsSelection, controlOptionsInput.value)"
                [value]="controlOptionsSelection.Value.toString()">
                @for (allowable of controlOptionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="controlOptionsSelection.Value && controlOptionsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (waterCircuitSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Water Circuit:</label>
              <select class="halfWidthInputField" #waterCircuitInput
                [class.invalidConfigurationSelection]="isInvalidSelection(waterCircuitSelection.Name)"
                (change)="selectionChanged(waterCircuitSelection, waterCircuitInput.value)"
                [value]="waterCircuitSelection.Value.toString()">
                @for (allowable of waterCircuitSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="waterCircuitSelection.Value && waterCircuitSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
        <div class="configurationDetailRow">
          @if (heatExchangerOptionsSelection) {
            <span class="fullWidthConfigurationInput">
              <label class="halfWidthInputLabel">Heat Exchanger Options:</label>
              <select class="halfWidthInputField" #heatExchangerOptionsInput
                [class.invalidConfigurationSelection]="isInvalidSelection(heatExchangerOptionsSelection.Name)"
                (change)="selectionChanged(heatExchangerOptionsSelection, heatExchangerOptionsInput.value)"
                [value]="heatExchangerOptionsSelection.Value.toString()">
                @for (allowable of heatExchangerOptionsSelection.Allowables; track allowable) {
                  <option
                    [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                    [selected]="heatExchangerOptionsSelection.Value && heatExchangerOptionsSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">{{ allowable.Description }}</option>
                }
              </select>
            </span>
          }
        </div>
      </div>
    </div>
  }
</div>
